<template>
  <div>
    <a-card title="档案模版" style="border: none; border-radius: 12px">
      <div slot="extra">
        <a-button
          @click="addOrUpdateHandleSelf('', 'edit')"
          icon="plus"
          style="background: #fff9f0; border: none; color: #ef9f22"
          v-permission="['file:filesprintSet:add']"
        >
          新建空白模板
        </a-button>
      </div>
      <a-row :gutter="[20, 20]" type="flex">
        <a-col :lg="12" :xl="6" v-for="(v, i) in fileArray" :key="i">
          <div class="item">
            <div class="fileimg">
              <img :src="v.img" alt="" />
            </div>
            <div class="filename">{{ v.name }}</div>
            <div class="tool">
              <div class="edit">
                <div
                  @click="addorupdate(v.id, 'edit')"
                  v-permission="['file:filesprintSet:edit']"
                >
                  编辑
                </div>
                <div
                  @click="addorupdate(v.id, 'show')"
                  v-permission="['file:filesprintSet:page']"
                >
                  查看
                </div>
              </div>
              <div
                class="download"
                @click="confirmExport(v.id)"
                v-permission="['file:filesprintSet:download']"
              >
                下载
              </div>
            </div>
          </div>
        </a-col>
        <a-col :lg="12" :xl="6" v-for="v in dataList" :key="v.id + '200'">
          <div class="item">
            <div class="fileimg">
              <img src="@/assets/image/kbmb.jpg" alt="" />
            </div>
            <div class="filename">{{ v.title }}</div>
            <div class="tool">
              <div class="edit">
                <div
                  @click="addOrUpdateHandleSelf(v.id, 'edit')"
                  v-permission="['file:filesprintSet:edit']"
                >
                  编辑
                </div>
                <div
                  @click="addOrUpdateHandleSelf(v.id, 'show')"
                  v-permission="['file:filesprintSet:page']"
                >
                  查看
                </div>
                <div
                  @click="deleteHandle(v.id)"
                  style="background: rgb(234, 19, 19); color: #fff"
                  v-permission="['file:filesprintSet:delete']"
                >
                  删除
                </div>
              </div>
              <div
                class="download"
                @click="confirmExportBlank('6-', v.title)"
                v-permission="['file:filesprintSet:download']"
              >
                下载
              </div>
            </div>
          </div>
        </a-col>
      </a-row>
    </a-card>
    <Fileupdate ref="fileupdate" @ok="init" />
  </div>
</template>

<script>
import viewModule from "@/mixins/view-module";
import Fileupdate from "./components/fileupdate";
import { fileInfo } from "@/request/file";
import { saveAs } from "file-saver";
import Saveprint from "@/utils/saveprint/index";
import moment from "moment";
export default {
  components: { Fileupdate },
  mixins: [viewModule],
  data() {
    return {
      fileArray: [
        {
          id: "1",
          name: "基本信息",
          img: require("@/assets/image/grxx.png"),
        },
        {
          id: "2",
          name: "个人承诺书",
          img: require("@/assets/image/grcns.png"),
        },
        {
          id: "3",
          name: "三级教育卡",
          img: require("@/assets/image/sjjyk.png"),
        },
        {
          id: "4",
          name: "劳动合同",
          img: require("@/assets/image/lwht.png"),
        },
      ],
      Save: null,
      mixinViewModuleOptions: {
        getDataListURL: "/filesBlank/list",
        deleteURL: "/filesBlank/delete",
      },
    };
  },
  mounted() {
    this.init();
  },
  methods: {
    addorupdate(id, type) {
      this.$refs.fileupdate.init(id, type);
    },
    addOrUpdateHandleSelf(id, type) {
      this.$refs.fileupdate.init("5", type, id);
    },
    //模板标题初始化
    init() {
      this.getDataList();
      fileInfo().then((res) => {
        this.fileArray[1].name = res.data.valueAtitle;
        this.fileArray[2].name = res.data.valueBtitle;
        this.fileArray[3].name = res.data.valueCtitle;
        this.$forceUpdate();
      });
    },
    //下载
    confirmExport(id) {
      fileInfo().then((re) => {
        // if (!this.Save) {
        const Save = new Saveprint();
        Save.setDowmloadSelf(function (res) {
          const excelData = new Blob([res.out], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8",
          });
          saveAs(excelData, res.title + ".docx");
        });
        // }
        // console.log(re.data);
        Save.fileInit([re.data], [id]);
      });
    },
    //空白模板下载
    confirmExportBlank(id, title) {
      const Save = new Saveprint();
      Save.setDowmloadSelf(function (res) {
        const excelData = new Blob([res.out], {
          type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=UTF-8",
        });
        saveAs(excelData, res.title + ".docx");
      });
      // }
      // console.log(re.data);
      Save.fileInit(
        [
          {
            blank_time: moment(new Date()).format("YYYY-MM-DD"),
          },
        ],
        [{ id: id, blank_title: title }]
      );
    },
  },
};
</script>

<style scoped>
.item {
  background: #f5f6fa;
  /* height: 470px; */
  padding: 20px;
  box-sizing: border-box;
  cursor: pointer;
  position: relative;
}
.fileimg {
  padding: 20px;
  box-sizing: border-box;
}
.fileimg img {
  max-width: 100%;
  max-height: 100%;
  box-shadow: 0px 3px 6px rgba(0, 0, 0, 0.16);
}
.filename {
  font-size: 14px;
  font-weight: bold;
  line-height: 20px;
  color: #011733;
  margin-top: 10px;
}

.tool {
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%;
  height: 60%;
  background: linear-gradient(
    180deg,
    rgba(0, 0, 0, 0) 0%,
    rgba(84, 84, 84, 0.4) 100%
  );
  transition: all 0.25s;
  opacity: 0;
  padding: 8% 0%;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
}
.item:hover .tool {
  opacity: 1;
}
.edit {
  display: flex;
  width: 100%;
  height: 54px;
}
.edit div {
  flex: 1 1;
  height: 54px;
  line-height: 54px;
  background: #ffffff;
  border-radius: 8px;
  font-size: 1rem;
  color: #0073ff;
  text-align: center;
  margin: 0 10px;
}
.download {
  height: 54px;
  line-height: 54px;
  background: #0073ff;
  text-align: center;
  border-radius: 8px;
  font-size: 1rem;
  margin: 20px 10px 0 10px;
  color: #ffffff;
}
</style>